import { FC, ReactNode } from 'react';
import { icons } from '../../../icons/IconSet';

const NoData: FC<{ 
  msg?: ReactNode
}> = ({
  msg = 'Data not found',
}) => (
  <div className="flex gap-3 justify-center w-[100%] text-slate-400">
    {icons('cloud-alert')}
    {msg}
  </div>
);

export default NoData;
